import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import LocationDistance from './LocationDistance.js';

function LocationDistanceContainer(_param) {
    var { distance , labels ={}  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "distance",
        "labels"
    ]);
    const { getLabel , getFormattedLabel  } = useIntl();
    const defaultLabels = React.useMemo(()=>swcHelpers.objectSpread({
            distance: getFormattedLabel('stores.location.distance', {
                labelData: {
                    distance: distance || ''
                }
            }),
            driving: getLabel('stores.location.drivingTime'),
            walking: getLabel('stores.location.walkingTime')
        }, labels)
    , [
        distance,
        labels,
        getFormattedLabel,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(LocationDistance, swcHelpers.extends({
        distance: distance,
        labels: defaultLabels
    }, rest));
}
var LocationDistanceContainer$1 = /*#__PURE__*/ React.memo(LocationDistanceContainer);

export { LocationDistanceContainer$1 as default };
//# sourceMappingURL=LocationDistanceContainer.js.map
